import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Box, Grid } from '@dhl-ui/components'
import { BackButton } from '~/temp-ds-component/BackButton'

import { links } from '~/AppRoutes'

import { PromoCodeDetails } from '~/modules/promocodes/components'

export const PromoCodeDetailsPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const onBack = () => navigate(links.promoCodesLink())

  return (
    <>
      <Box marginBottom={2}>
        <BackButton onClick={onBack}>{t('admin.promoCodesPage.backButton')}</BackButton>
      </Box>
      <Box>
        <Grid size={{ sm: 6 }}>
          <PromoCodeDetails />
        </Grid>
      </Box>
    </>
  )
}
